import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Modal } from 'flowbite-react';
import { style } from "./ModalSignUp";
import CryptoJS from 'crypto-js'
import { KEY } from "../config";

import ErrorWrapper from "./ErrorWrapper";
import Loading from "./Loading";

import MyAuthContext from "../context/AuthContext";

const ModalLogIn = ({ isModalLogInOpen, setIsModalLogInOpen, setIsModalSignUpOpen, setIsModalPasswordRecoverOpen }) => {
    const { login, loading } = useContext(MyAuthContext);

    const [error, setError] = useState({"error": false, "message": ""});
    const [shownPassword, setShownPassword] = useState(false);
    const switchShownPassword = () => setShownPassword(!shownPassword)

    const schema = yup.object().shape({
        userEmail: yup.string().email("El correo es inválido").required("El correo es requerido"),
        userPassword: yup.string().required("La contraseña es requerida"),
    })

    const { handleSubmit, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        setError({"error": false, "message": ""});
        const res = await login(data);
        if(res.error){
            setError({"error": true, "message": res.response});
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 10000);
        }else{
            window.localStorage.setItem("userRole", CryptoJS.AES.encrypt(res.response.userRole, KEY).toString());
            window.localStorage.setItem("session", CryptoJS.AES.encrypt("true", KEY).toString());
            window.localStorage.setItem("tokenUser", res.response.token);
            if(res.response.userRole === "1"){
                window.location.assign("/control");
            } else if(res.response.userRole === "2"){
                window.location.assign("/perfil");
            }
            closeModal();
        }
    }

    const closeModal = () => {
        setIsModalLogInOpen(false)
        reset()
    }

    return (
        <>
            <Modal show={isModalLogInOpen} style={{height:"100%"}} position="center" size="md">
                <div class="flex flex-col items-center justify-center mx-auto lg:w-[100%]">
                    <div className='w-full bg-white rounded-lg shadow'>
                        <div class="p-6 space-y-4">
                            <div class="flex flex-row py-3">
                                <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">Inicia Sesión</h1>
                                <button className='absolute font-bold top-2 right-3' onClick={() => closeModal()}>x</button>
                            </div>
                            <form onSubmit={handleSubmit(onSubmit)} class="space-y-4">
                                <div class="relative z-0 mb-6 w-full group">
                                    <input type="email" {...register("userEmail")} class={style.formInput} placeholder=" "/>
                                    <label class={style.formLabel}>Correo Electrónico</label>
                                    <ErrorWrapper error={errors.userEmail?.message} />
                                </div>
                                <div class="mb-6 ">
                                    <div class="relative z-0  w-full group">
                                        <input type={shownPassword ? 'text' : 'password'} {...register("userPassword")} class={style.formInput} placeholder=" " />
                                        <button class="absolute transform  translate-y-[-50%] top-[50%] right-3" type="button" onClick={switchShownPassword}>
                                            {shownPassword ? <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg> : <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path></svg>}
                                        </button>
                                        <label class={style.formLabel}>Contraseña*</label>
                                
                                    </div>
                                    <ErrorWrapper error={errors.userPassword?.message}/>
                                </div>
                                
                                <div className='text-center w-full'>
                                    {error.error && <ErrorWrapper error={error.message} />}
                                </div>
                                {loading ? <Loading isLoading={true} /> : <button type="submit" class="flex mx-auto bg-gray-300 border shadow hover:text-white hover:bg-teal-400 focus:ring-4 focus:outline-none focus:ring-teal-300 font-medium rounded-lg text-sm w-full w-auto px-5 py-2.5 text-center">Iniciar Sesión</button>}
                                <div class="flex flex-row">
                                    <button type="button" onClick={()=> {setIsModalPasswordRecoverOpen(true); closeModal()}} class="float-right text-sm font-medium text-teal-500 hover:underline mx-auto">¿Olvidó su Contraseña?</button>
                                </div>
                                <p class="text-sm font-light text-gray-500">
                                    ¿No tiene una Cuenta? <button type="button" onClick={()=> {setIsModalSignUpOpen(true);closeModal() }} class="font-medium text-teal-500 hover:underline">Registrese</button>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>

            </Modal>
        </>
    );
}

export default ModalLogIn;